import React from "react";
import { cn } from "@/lib/utils";

/**
 * Selo "Aberta"/"Fechada" da loja (campo `available` da empresa).
 * Sem empresa em foco (owner em "todas as empresas") não exibe nada.
 */
const StoreStatusBadge = ({ company, className }) => {
  if (!company) return null;
  const open = !!company.available;

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-2.5 py-1 text-[11px] font-bold",
        open
          ? "border-primary/20 bg-secondary text-primary"
          : "border-terra/20 bg-terra-soft text-terra",
        className,
      )}
      title={open ? "Loja recebendo pedidos" : "Loja fechada para pedidos"}
    >
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          open ? "animate-pulse bg-primary" : "bg-terra",
        )}
      />
      {open ? "Aberta" : "Fechada"}
    </span>
  );
};

export default StoreStatusBadge;
